module.exports = __webpack_public_path__ + "img/zh_cn.59f12f4f.png";